<template>
  <van-dialog v-model="showPlayer" @close="close" :show-confirm-button="false" class="mall-dialog-player" :class="{
    'mall-dialog-audio': theme == 'audio',
    'mall-dialog-video': theme == 'video',
    'fullscreen': fullscreen
  }">
    <div class="inner">
      <mall-player :theme="theme" ref="player" :src="src" />
      <button type="button" class="close" @click="showPlayer = false"></button>
    </div>
  </van-dialog>
</template>

<script>
import MallPlayer from './Player';

export default {
  name: 'MallPlayerDialog',

  components: {
    MallPlayer
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    src: {
      type: String,
      default: ''
    },

    theme: {
      type: String,
      default: 'video'
    },

    fullscreen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showPlayer: false
    };
  },

  watch: {
    value(val) {
      if (val) {
        this.play();
      }
      else {
        this.stop();
      }
    }
  },

  created() {
    this.showPlayer = this.value;
  },

  methods: {
    play() {
      this.showPlayer = true;
      this.$nextTick(() => {
        this.$refs.player.play();
      });
    },

    stop() {
      this.showPlayer = false;
      this.$refs.player?.stop();
    },

    close() {
      this.stop();
      this.$emit('input', false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@cdn_css/helper.scss";

.mall-dialog-player {
  &.van-dialog {
    width: 100%;
    background-color: transparent;
    border-radius: 0;

    .inner {
      position: relative;
      max-width: 10rem;
      margin: 0 auto;
    }
  }

  &.mall-dialog-audio {
    overflow: visible;

    .inner {
      padding-right: 15px;
      padding-left: 15px;
    }

    .close {
      position: absolute;
      bottom: -70px;
      left: 50%;
      width: 40px;
      height: 40px;
      background-color: transparent;
      background-position: center;
      border: 0;
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 50%;
      @include bg-img('~@cdn_img/icon-28.svg', 11px 11px);
      @extend %center-x;
    }
  }

  &.mall-dialog-video {
    top: 50%;
    height: 90%;

    ::v-deep {
      .van-dialog__content {
        height: 100%;
      }

      .plyr--video {
        height: 100%;
      }
    }

    .inner {
      height: 100%;
    }

    &.fullscreen {
      height: 100%;

      ::v-deep {
        .plyr__controls {
          flex-wrap: wrap;

          &:after {
            display: block;
            width: 100%;
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
            content: "";
          }
        }

        video {
          object-fit: cover;
        }
      }
    }

    .close {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 24px;
      height: 24px;
      background-color: transparent;
      border: 0;
      @include bg-img('~@cdn_img/icon-28.svg', contain);
    }
  }
}
</style>
